import React from 'react';
import ConfirmationDF from '../components/SimulatorsComponents/DefualtSimulators/ConfirmationDF';
import { Price_100, show_details } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Sim_G10_SplitPaymentConfirmation = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <ConfirmationDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    stringButtom={Price_100}
    showOnlyFirstPage
    isConfirmation_split
    withOutIconLine
    withOutTopTitle
    blueStr={show_details}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_G10_SplitPaymentConfirmation;
